import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { useI18N } from '../../../libraries/i18n/hook'
import ArrowIcon from '../../../assets/icons/arrow-right.svg?react'
import ArrowHeadIcon from '../../../assets/icons/arrow-head-right.svg?react'

type Props = { responsive?: boolean, link?: string }
const GoBackLink: React.FC<Props> = ({ responsive = true, link }) => {
  const { t } = useI18N()
  const navigate = useNavigate()

  const handleClick = (e: React.MouseEvent) => {
    if (!link) {
      e.preventDefault()
      navigate(-1)
    }
  }

  return (
    <Link to={link || ''} onClick={handleClick} replace>
      <div className={` ${responsive ? 'hidden' : 'flex'} lg:flex items-center text-sm text-black`}><ArrowIcon className='w-4 rotate-180 mr-1 fill-deep-green' />{t('common.back')}</div>
      {responsive && <div className='block rotate-180 lg:hidden'><ArrowHeadIcon className='stroke-deep-green h-6 ml-1' /></div>}
    </Link>
  )
}

export default GoBackLink
